import { checkEnvironment } from '@saviynt/common';

const getRolesDetailsApiUrl = (roleKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/roles/${roleKey}`;
};

export default getRolesDetailsApiUrl;
